import * as React from 'react'
import { Input, Switch, Typography } from 'antd'
import { CheckOutlined, CloseOutlined } from '@ant-design/icons'
import { Qualifications } from './MainCSoftAccess'
const { Text } = Typography

interface IProps {
  qualifications:    Qualifications
  setQualifications: React.Dispatch<React.SetStateAction<Qualifications>>
}

export default function CQualifications(props: IProps){

    return (
      <div id="qualifications">
        {['1','2','3','4'].map((idQualification: string, index: number) => (
          <div key={index} className='div-switch'>
            {/* Switch to display or not the fields of the pdv block's informations */}
            <Switch
              id                = {`qualification${idQualification}_displayed`}
              checkedChildren   = {<CheckOutlined />}
              unCheckedChildren = {<CloseOutlined />}
              style             = {{marginRight: '15px'}}
              checked           = {props.qualifications.qualificationNotEmpty[index]}
              onChange          = {(checked: boolean) => {
                const updatedQualificationNotEmpty  = [...props.qualifications.qualificationNotEmpty]
                updatedQualificationNotEmpty[index] = checked
                props.setQualifications({
                  ...props.qualifications,
                  qualificationNotEmpty: updatedQualificationNotEmpty
                })
              }}
            />
            <b style={{fontSize: '17px'}}>Qualification {idQualification}</b> 
            {props.qualifications.qualificationNotEmpty[index] && (
              <div>
                {/* Choose the name of the qualification as an input text */}
                <div className="div-text-input">
                  <Text className='text-before-input'>Nom</Text>
                  <Input
                    id       = {`qualification_json_qualif${idQualification}_nom`}
                    name     = {`qualification_json.qualif${idQualification}.nom`}
                    style    = {{borderRadius: '4px'}}
                    value    = {props.qualifications.qualification_json[`qualif${idQualification}`].nom}
                    onChange = {(e) => {
                      props.setQualifications({
                        ...props.qualifications,
                        qualification_json: {
                          ...props.qualifications.qualification_json,
                          [`qualif${idQualification}`]: {
                            ...props.qualifications.qualification_json[`qualif${idQualification}`],
                            nom: e.target.value
                          }
                        }
                      })
                    }}
                  />
                </div>
                {/* Choose the legend of the qualification as an input text */}
                <div className="div-text-input">
                  <Text className='text-before-input'>Légende</Text>
                  <Input
                    id       = {`qualification_json_qualif${idQualification}_legende`}
                    name     = {`qualification_json.qualif${idQualification}.legende`}
                    style    = {{borderRadius: '4px'}}
                    value    = {props.qualifications.qualification_json[`qualif${idQualification}`].legende}
                    onChange = {(e) => {
                      props.setQualifications({
                        ...props.qualifications,
                        qualification_json: {
                          ...props.qualifications.qualification_json,
                          [`qualif${idQualification}`]: {
                            ...props.qualifications.qualification_json[`qualif${idQualification}`],
                            legende: e.target.value
                          }
                        }
                      })
                    }}
                  />
                </div>
                {/* See the color of the qualification as an input text disabled */}
                <div className="div-text-input">
                  <Text style={{textAlign: 'right', paddingRight: '20px', color: props.qualifications.qualification_json[`qualif${idQualification}`].color}}>Couleur</Text>
                  <Input
                    id       = {`qualification_json_qualif${idQualification}_color`}
                    name     = {`qualification_json.qualif${idQualification}.color`}
                    style    = {{borderRadius: '4px'}}
                    disabled
                    value    = {props.qualifications.qualification_json[`qualif${idQualification}`].color}
                    onChange = {(e) => {
                      props.setQualifications({
                        ...props.qualifications,
                        qualification_json: {
                          ...props.qualifications.qualification_json,
                          [`qualif${idQualification}`]: {
                            ...props.qualifications.qualification_json[`qualif${idQualification}`],
                            color: e.target.value
                          }
                        }
                      })
                    }}
                  />
                </div>
              </div>
            )}
          </div>
        ))}
          
      </div>
    )                   
}
